
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkSettlementDetailsGrid extends Serenity.EntityGrid<JobWorkSettlementDetailsRow, any> {
        protected getColumnsKey() { return 'Production.JobWorkSettlementDetails'; }
        protected getDialogType() { return JobWorkSettlementDetailsDialog; }
        protected getIdProperty() { return JobWorkSettlementDetailsRow.idProperty; }
        protected getInsertPermission() { return JobWorkSettlementDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return JobWorkSettlementDetailsRow.localTextPrefix; }
        protected getService() { return JobWorkSettlementDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}